<template>
  <v-container class="pa-0" v-if="schedule" grid-list-md text-xs-center>

    <template v-for="(d, dayIndex) in days">
      <v-list subheader two-line :key="'day' + dayIndex">
        <div class="pa-0" v-if="schedule[d].length > 0">
          {{ d | capitalize }}</div>
        <div v-if="schedule[d].length > 0">
          <template v-for="(c, hourIndex) in schedule[d]">
            <v-list-item :key="d + hourIndex" @click.stop="doNothing()" class="pl-0 pr-0 pt-0 mb-1"
              :style="c.color ? 'border-left: 4px solid ' + c.color + '; padding-left: 16px;' : ''">
              <v-list-item-content :style="c.color ? 'padding-left: 8px;' : ''">
                <v-list-item-title>{{ c.name }}</v-list-item-title>
                <v-list-item-subtitle v-if="c.professorUser">{{ displayProfessorName(c.professorUser)
                  }}</v-list-item-subtitle>
                <v-list-item-subtitle>{{ $d(numberToDate(c.start), "time", $i18n.locale) }} - {{ $d(numberToDate(c.end),
                  "time", $i18n.locale) }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>
        </div>
      </v-list>
    </template>
  </v-container>
</template>
<script>

export default {
  data() {
    return {
      days: [
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday",
        "sunday"
      ],
      hours: this.initializeHours()
    };
  },
  components: {},
  props: {
    schedule: null,
    professors: null
  },
  created() {
  },
  mounted() {
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  methods: {
    displayProfessorName(id) {
      if (id && this.professors && this.professors[id]) {
        return this.professors[id].displayName;
      }
    },
    initializeHours() {
      const hours = [];
      for (let hour = 6; hour < 24; hour++) {
        for (let min = 0; min < 60; min += 5) {
          const value = parseFloat(`${hour}.${String(min).padStart(2, '0')}`);
          const display = `${hour}:${String(min).padStart(2, '0')}`;
          hours.push({ display, value });
        }
      }
      return hours;
    },
    doNothing() { },
    numberToString(time) {
      const split = time.toString().split(".");
      if (split.length > 1) {
        return `${split[0]}:${split[1].padEnd(2, '0')}`;
      }
      return `${time}:00`;
    },
    numberToDate(time) {
      const split = time.toString().split(".");
      const hoursString = split[0];
      const minutesString = split.length > 1 ? split[1].padEnd(2, '0') : "00";
      const d = new Date();
      d.setHours(hoursString);
      d.setMinutes(minutesString);
      d.setSeconds(0);
      return d;
    }
  }
};
</script>

<style scoped></style>
